// Country-based pricing configuration
// Each country has its own base pricing and service fee structure

export const countryPricingConfig = {
  'AU': { 
    currency: 'AUD', 
    defaultServiceFee: 41.66,
    basePricing: {
      hourly: 6000, // $60 AUD per hour
      daily: 84000, // $240 AUD per day
      fixed: 12000  // $120 AUD fixed
    }
  },
  'US': { 
    currency: 'USD', 
    defaultServiceFee: 41.66,
    basePricing: {
      hourly: 4500, // $45 USD per hour
      daily: 18000, // $180 USD per day
      fixed: 9000   // $90 USD fixed
    }
  },
  'GB': { 
    currency: 'GBP', 
    defaultServiceFee: 41.66,
    basePricing: {
      hourly: 3500, // £35 GBP per hour
      daily: 14000, // £140 GBP per day
      fixed: 7000   // £70 GBP fixed
    }
  }
};

export const supportedCountries = [
  { code: 'AU', name: 'Australia', currency: 'AUD' },
  { code: 'US', name: 'United States', currency: 'USD' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP' }
];

// Helper functions
export const getCountryPricing = (countryCode) => {
  return countryPricingConfig[countryCode] || countryPricingConfig['AU'];
};

export const getSupportedCountryCodes = () => {
  return supportedCountries.map(country => country.code);
};

export const isCountrySupported = (countryCode) => {
  return Object.keys(countryPricingConfig).includes(countryCode);
};

export const getDefaultCountry = () => {
  return 'AU';
}; 